<template>
	<component
		:is="componentMap[state.currentQuestion.questionType]"
		ref="steps"
		@prev="prevStep"
		@next="nextStep"
		@setAnswer="setAnswer"
	/>
	<!--References List-->
	<Teleport to="[data-teleport-references]">
		<ReferencesList
			v-if="state.currentQuestion?.referenceItems"
			:references="state.currentQuestion.referenceItems"
			:list-type="state.currentQuestion.referenceListStyleType"
		/>
	</Teleport>
	<div class="c-health-check-tool__slide-actions">
		<DsButtonGroup mobile-direction="row" mobileAlignment="start">
			<DsIconButton
				:aria-label="labels.prev"
				icon-name="navigate-back"
				:clickHandler="prevStep"
				:disabled="!state.currentQuestion.showPreviousButton"
			></DsIconButton>
			<DsButton
				variant="primary"
				icon-end="checkmark"
				:clickHandler="submit"
				v-if="state.currentQuestion.showSubmitButton"
			>
				{{ labels.submit }}
			</DsButton>
			<DsButton
				variant="primary"
				icon-end="navigate-forward"
				:clickHandler="nextStep"
				v-if="state.currentQuestion.showNextButton"
			>
				{{ labels.next }}
			</DsButton>
		</DsButtonGroup>
	</div>
</template>

<script setup>
import SingleButton from './singleChoiceQuestion.vue';
import MultipleChoice from './multipleChoiceQuestion.vue';
import Date from './dateChoiceQuestion.vue';
import ReferencesList from 'shared/components/ReferencesList.vue';
import {
	DsButton,
	DsIconButton,
	DsButtonGroup,
} from '@coloplast/design-system';
import { useHealthCheckState } from '../useHealthCheckState';

defineProps({
	labels: {
		type: Object,
		required: true,
	},
	goToLastStep: {
		type: Boolean,
		default: false,
	},
});

const componentMap = {
	SingleButton,
	MultipleChoice,
	Date,
};

const { state } = useHealthCheckState();
const emit = defineEmits(['prev', 'next', 'setAnswer', 'submit']);

function prevStep() {
	emit('prev');
}

function nextStep() {
	state.currentQuestion.isTouched = true;

	if(state.currentQuestion.isTouched && state.currentQuestion.isValid) {
		emit('next');
	}
}

function setAnswer(data) {
	if (!data.notCollect) {
		emit('setAnswer', data);
	}
}

function submit(data) {
	emit('submit', data);
}
</script>

<style lang="scss" scoped>
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.c-health-check-tool__slide-body {
	display: flex;
	flex-direction: column;
	row-gap: ds-space(4);
	width: 100%;
}

.c-health-check-tool__slide-actions {
	width: 100%;

	& .ds-button-group {
		--flex-alignment: space-between;
	}
}

:deep(.ds-hc-option__image) {
	object-fit: contain;
}
</style>
